import * as React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import styled from "@emotion/styled";

const StyledBox = styled(Box)(({ theme }) => ({
  "& .MuiTypography-body2": {
    [theme.breakpoints.up("sm")]: {
      fontSize: "14px !important",
    },
    [theme.breakpoints.up("xs")]: {
      fontSize: "12px !important",
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: "8px !important",
    },
  },
  "& .MuiCheckbox-root": {
    padding: "2px",
  },
}));

export default function CheckboxTest(props) {
  const {
    variations,
    currentVariation,
    currentLevelConfig,
    onVariationClick,
    onSubVariationClick,
  } = props;

  return (
    <StyledBox
      key={currentVariation}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "inherit",
      }}
    >
      <Typography
        variant={"body2"}
      >{`Please select ${currentLevelConfig.maxQuantity} item`}</Typography>
      <List
        sx={{
          width: "100%",
          maxWidth: 360,
          bgcolor: "background.paper",
          padding: "0px",
        }}
      >
        {variations.map((value, index) => {
          const id = value.id;
          const labelId = `checkbox-list-label-${id}`;

          return (
            <>
              <ListItem
                key={id}
                disablePadding
                sx={{ fontSize: { xs: "0.475rem", md: "0.675rem" } }}
              >
                <ListItemButton
                  key={id}
                  role={undefined}
                  onClick={() => onVariationClick(id)}
                  dense
                  style={{ height: "30px" }}
                >
                  <ListItemIcon key={id}>
                    <Checkbox
                      key={id}
                      edge="start"
                      checked={value.enabled}
                      tabIndex={-1}
                      disableRipple
                      inputProps={{ "aria-labelledby": labelId }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    key={id + value.name}
                    id={labelId}
                    primary={`${value.name} ${
                      value?.price > 0 ? ` (${value?.price.toFixed(2)})` : ""
                    }`}
                    sx={{ fontSize: { xs: "0.475rem ", md: "0.675rem" } }}
                  />
                </ListItemButton>
              </ListItem>
              {value.enabled && currentVariation === id ? (
                <Box
                  key={value.id + value.name}
                  sx={{ display: "flex", flexDirection: "column", ml: 3 }}
                >
                  {(value?.subVariations || []).map((x, index) => {
                    return (
                      <List
                        key={x.id + x.name}
                        sx={{
                          width: "100%",
                          maxWidth: 360,
                          bgcolor: "background.paper",
                          padding: "0px",
                        }}
                      >
                        <ListItem key={x.id} disablePadding>
                          <ListItemButton
                            key={x.id}
                            role={undefined}
                            onClick={async () =>
                              await onSubVariationClick(index)
                            }
                            dense
                            style={{ height: "30px" }}
                          >
                            <ListItemIcon key={x.id}>
                              <Checkbox
                                key={x.id}
                                edge="start"
                                checked={x.enabled}
                                tabIndex={-1}
                                disableRipple
                              />
                            </ListItemIcon>
                            <ListItemText
                              key={x.id + x.name}
                              id={labelId}
                              primary={x.name}
                              sx={{
                                fontSize: { xs: "0.675rem", md: "1rem" },
                              }}
                            />
                          </ListItemButton>
                        </ListItem>
                      </List>
                    );
                  })}
                </Box>
              ) : null}
            </>
          );
        })}
      </List>
    </StyledBox>
  );
}
